import { Link } from 'react-router-dom';

export default function AboutSection() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-gradient-to-b from-foreground-900 to-foreground-950 text-white">
      <div className="max-w-6xl mx-auto">
        <div className="mb-8">
          <span className="inline-block px-3 py-1 bg-primary-500/20 text-primary-300 text-xs rounded-full mb-4 whitespace-nowrap">
            关于我们 / ABOUT
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-white mb-4 max-w-2xl">
            重新定义吃瓜体验，让每一条爆料都有据可查
          </h2>
          <p className="text-sm md:text-base text-foreground-300 max-w-xl leading-relaxed">
            911吃瓜网致力于打造国内领先的网红娱乐资讯聚合平台，我们坚持"快、准、深"的内容原则，每日实时追踪网红塌房、明星八卦、社会奇闻，为吃瓜群众提供最及时、最全面的第一手爆料内容。
          </p>
        </div>

        <div className="flex flex-col lg:flex-row items-center gap-10 mt-12">
          <div className="w-full lg:w-1/2">
            <img
              src="https://readdy.ai/api/search-image?query=Modern%20newsroom%20with%20multiple%20screens%20displaying%20breaking%20news%2C%20warm%20lighting%2C%20professional%20workspace%2C%20editorial%20photography%2C%20clean%20aesthetic%2C%20light%20and%20airy%20atmosphere&width=800&height=600&seq=about-platform-01&orientation=landscape"
              alt="911吃瓜网平台形象"
              title="911吃瓜网 - 专业吃瓜资讯平台"
              className="w-full rounded-2xl object-cover"
              loading="lazy"
            />
          </div>
          <div className="w-full lg:w-1/2">
            <div className="text-5xl md:text-7xl font-heading font-bold text-white mb-4">
              50,000+
            </div>
            <p className="text-sm text-foreground-300 leading-relaxed mb-2">
              累计收录爆料内容超过五万条
            </p>
            <p className="text-sm text-foreground-300 leading-relaxed mb-6">
              覆盖网红塌房、明星八卦、社会奇闻等多个领域，日均更新速度业界领先，深受百万瓜友信赖。
            </p>
            <Link
              to="/about"
              className="inline-flex items-center gap-1.5 px-5 py-2.5 border border-white/30 text-white text-sm rounded-full hover:bg-white/10 transition-all duration-200 cursor-pointer whitespace-nowrap"
            >
              了解我们
              <i className="ri-arrow-right-line text-xs"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}